<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting sticky">
        <h2>Ngân hàng</h2>
      </div>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="line">
          <el-upload
            class="course-uploader"
            :action="upload.url_not_resize"
            :headers="upload.headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-progress="handleAvatarProcess"
            :before-upload="beforeAvatarUpload">
            <img v-if="image_path" :src="image_path" class="courseSettig">
          </el-upload>
          <span style="padding-left: 30px;">{{ image }}</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content bank-item ">
        <el-col :span="24">
          <div v-for="(category) in homeMenu" :key="category.key">
            <div class="line line-1 pt-2">
              <input type="text" placeholder="Tên nhóm" v-model="category.name">
              <!-- <input type="text" placeholder="Hình ảnh" v-model="category.image"> -->
              <input type="text" placeholder="Ưu tiên" v-model="category.priority">
              <el-button @click.prevent="removeCategory(category, homeMenu)" size="mini">Xóa</el-button>
            </div>
            <div style="padding-left: 80px;">
              <div v-for="(set) in category.options" :key="set.key">
                <div class="line line-2">
                  <div class="d-flex flex-column">
                    <input type="text" placeholder="Ảnh" v-model="set.image">
                    <input type="text" placeholder="Tên ngân hàng" v-model="set.name">
                    <input type="text" placeholder="Chi nhánh" v-model="set.brank">
                    <input type="text" placeholder="Số tài khoản" v-model="set.number">
                    <input type="text" placeholder="Chủ tài khoản" v-model="set.account_holder">
                    <input type="text" placeholder="Ưu tiên" v-model="set.priority">
                  </div>
                  <div>
                    <img :src="getImage(set.image)" alt="" class="image-preview">
                  </div>
                  <el-button @click.prevent="removeSet(set, category.options)" size="mini">Xóa</el-button>
                </div>
              </div>
              <el-button class="huhu" type="info" size="mini" @click="addSet(category.options)">Thêm ngân hàng</el-button>
            </div>
          </div>
          <el-button class="huhu" type="primary" size="mini" @click="addCategory()">Thêm nhóm</el-button>
        </el-col>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModelHomeMenu()">Cập nhật</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'Config Bank',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Ngân hàng'
    }
  },
  data () {
    return {
      canSubmit: true,
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      homeMenu: [],
      image: '',
      image_path: '',
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'configs/upload',
        url_not_resize: process.env.API_URI + 'configs/upload-not-resize',
        headers: {
          Authorization: ''
        }
      },
      dialogVisible: false,
      modelData: {
        id: ''
      },
      model_temp: {}
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModelHomeMenu()
    this.configUpload()
  },
  methods: {
    getIndexCourse (index1, index2, count1, count2) {
      return index2 + 1
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Ngân hàng' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    getImage (data) {
      return process.env.IMAGE_URL + 'storage/images/configs/' + data
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.get('configs/bank-default').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.homeMenu = response.data.value
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModelHomeMenu (formName) {
      this.canSubmit = false
      let data = {
        'key': 'bank-default',
        'value': this.homeMenu
      }
      axios.put('configs/3', data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.fetchModelHomeMenu()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    addCategory () {
      this.homeMenu.push({
        'key': Math.floor(Math.random() * 10000000000) + 1,
        'name': '',
        'image': '',
        'priority': '',
        'options': []
      })
    },
    addSet (option) {
      let temp = {
        'key': Math.floor(Math.random() * 10000000000) + 1,
        'name': '',
        'image': '',
        'brank': '',
        'number': '',
        'account_holder': '',
        'priority': ''
      }
      option.push(temp)
    },
    addColor (option) {
      let temp = {
        'key': Math.floor(Math.random() * 10000000000) + 1,
        'name': '',
        'code': '',
        'priority': ''
      }
      option.push(temp)
    },
    removeSet (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    },
    removeCategory (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    },
    removeColor (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
    },

    // Phần thêm xóa kì, môn của chuyên ngành

    addTerm () {
      let temp = {
        'day': 90,
        'total_money': 5000000,
        'course_terms': []
      }
      this.modelData.courses_default.push(temp)
    },

    addCourse (option) {
      let temp = {
        'course_id': Math.floor(Math.random() * 10000000000) + 1,
        'course_name': '',
        'course_code': '',
        'course_term': '',
        'course_position': ''
      }
      option.push(temp)
    },

    removeCourse (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
        this.$message({
          message: 'Đã xóa mã môn ' + item.course_code,
          type: 'success'
        })
      }
    },

    removeTerm (item, options) {
      var index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
        this.$message({
          message: 'Đã xóa kì ',
          type: 'success'
        })
      }
    },

    // Phần cập nhật danh sách môn học trong chuyên ngành
    updateFacult (model) {
      this.model_temp = model
      this.dialogVisible = true
      axios.get('facults/' + model.key).then(response => {
        switch (response.code) {
          case 200:
            this.modelData = response.data
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    charegePaymentForUser () {
      this.canSubmit = false
      axios.put('facults/' + this.modelData.key, this.modelData).then(response => {
        this.canSubmit = true
        // this.dialogVisible = false
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.updateFacult(this.model_temp)
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.image = response.data.name
        this.image_path = response.data.path_sm
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
  height: 100vh - 120px;
  overflow-y: scroll;
}
.huhu {
  margin-top: 10px;
  margin-bottom: 10px;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.line-1 {
  background-color: #eaeeaa;
  padding: 5px 5px;
}
.line-2 {
  background-color: #ccc;
  padding: 5px 5px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 100px;
  width: 100px;
  margin-right: 10px;
  margin-left: 10px;
}

.main-term {
  background-color: #f2f2f2;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 5px 10px;
}
.main-term .text {
  font-weight: bold;
  font-size: 18px;
  margin-right: 40px;
}

.main-term .el-input {
  width: 250px;
  margin-left: 10px;
}
.course-terms {
  padding-left: 80px;
  padding-right: 80px;
}

.bank-item input {
  margin-bottom: 5px;
  width: 300px;
  height: 32px;
  padding-left: 5px;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/Update3.vue